import { Paragraph, Popover } from '@zillow/constellation-10';

type SpecialOfferCellProps = {
  specialOfferDescription: string | null | undefined;
};

export const SpecialOfferCell = ({ specialOfferDescription }: SpecialOfferCellProps) => {
  const trimmedDescription = specialOfferDescription?.trim();

  if (!trimmedDescription) {
    return <>-</>;
  }

  return (
    <Popover
      body={<Paragraph textStyle="body-sm">{trimmedDescription}</Paragraph>}
      closeButton={<span hidden />}
      header={null}
      trigger={
        <button
          type="button"
          onClick={(e) => e.stopPropagation()}
          style={{
            padding: '4px 8px',
            backgroundColor: '#e3f2fd',
            color: '#1976d2',
            borderRadius: '4px',
            border: 'none',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: 500,
            whiteSpace: 'nowrap',
          }}
        >
          Special offer
        </button>
      }
      shouldAwaitInteractionResponse
      tone="neutral"
    />
  );
};
